import { defineMessages } from 'react-intl';

export default defineMessages({
  barChart: 'Bar Chart',
  pieChart: 'Pie Chart',
  lineChart: 'Line Chart',
  areaChart: 'Area Chart',
  stackedBarChart: 'Stacked Bar Chart',
  table: 'Table',
  nestedTable: 'Nested table',
  nestedTableEmptyNested: 'No rows for this breakdown.',
  widget: 'Widget',

  matomoVisits: 'Visits',
  matomoActions: 'Actions',
  segment: 'Segment',
  totals: 'Totals',
  all: 'All visits',
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
  YEAR: 'Year',
});
